<template>
  <div
    class="flex items-center py-5 space-x-1 text-xs text-gray-700"
    v-if="property"
  >
    <!-- <div class="font-semibold"> -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
      />
    </svg>

    <!-- </div> -->

    <a href="/new-projects" class="ml-1 text-primary">Back to New Projects</a>
    <p class="px-1 text-gray-300">|</p>
    <HomeSvg color="primary" height="3" width="3" />
    <p class="text-gray-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <p class="text-primary">Ghana</p>
    <p class="text-primary">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <p class="text-primary">{{ property.city.name }}</p>
    <p class="text-gray-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <p class="text-gray-500">{{ property.title }}</p>
  </div>
</template>
<script>
import HomeSvg from "@/components/svg/HomeSvg.vue";
export default {
  components: { HomeSvg },
  name: "BreadCrumb",
  props: {
    property: Object,
  },
};
</script>
